var indentation_default = {
  "indentZero": "xm74Y",
  "indentOne": "jGGCL",
  "indentTwo": "uN2vK",
  "indentThree": "D0HF1",
  "indentFour": "_-3PQ5",
  "indentFive": "bFR-B",
  "indentSix": "OE-vI"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
